import {get,post} from '@/utils/request'

// 登录
export const login = params => get("open/index/login",params);
// 退出登录
export const logout = params => get("api/index/logout",params);
// 查询员工学习计划
export const findUserLearningByUserId = params => get("api/elpSysUser/findUserLearningByUserId",params);
// 查询学习详情
export const elpUserLearningPlanItemFindById = params => get("api/elpUserLearningPlanItem/findById",params);
// 学习详情打卡
export const elpUserPunch = params => post("api/elpUserPunch/punch",params);
// 学习打卡翻页
export const elpUserLearningPlanItemPage = params => get("api/elpUserLearningPlanItem/page",params);
// 查看考题
export const findExaminationAndQuestionsByExaminationId = params => get("api/elpUserExaminationPlan/findExaminationAndQuestionsByExaminationId",params);
// 查看考题(通过学习计划id)
export const findExaminationAndQuestionsByLearningId = params => get("api/elpUserExaminationPlan/findExaminationAndQuestionsByLearningId",params);
// 提交考试
export const submitExamination = params => post("api/elpUserExaminationQuestions/submitExamination",params);
// 缓存学习笔记
export const saveElpUserPunchSessionNoteApi = params => post("api/elpUserPunch-session-note/saveElpUserPunchSessionNote",params)
// 获取视频播放时长
export const findElpLearningDurationApi = params => get("api/elpUserLearningPlanItem/findElpLearningDuration",params);
// 视频播放心跳接口
export const elpLearningDurationOnMessageApi = (userId,params) => post("api/elpLearningDuration/onMessage/" + userId,params);







